import { getOrderingDefinitionIds } from './getOrderingDefinitionIds';
import type { PossibleFinderQuery } from './shared';

/**
 * given an observable finder query and an array of changed field def ids, determine
 * if the query's order could have possibly changed (thus necessitating a refetch)
 * */
export const getIsOrderPossiblyChanged = (
  query: PossibleFinderQuery,
  changedFieldDefIds: string[]
) => {
  const ids = getOrderingDefinitionIds(query);
  return changedFieldDefIds.some((id) => ids.includes(id));
};
